import { EnvironmentInterface } from './environment.type';

/**
 * Production build.
 *
 * Use this when deploying the PWA to production.
 */
export const environment = {
  name: 'Production',
  appName: import.meta.env.NG_APP_NAME,
  version: import.meta.env.NG_APP_VERSION,
  production: true,
  serviceWorker: true,
  apiUrl: 'https://app.switchdin.com',
  weatherAPIURL: 'https://api.openweathermap.org',
  eguanaReferrerUrl: '_',
  mqttConfig: {
    url: 'wss://app.switchdin.com:443/ws/',
    connectTimeout: 300 * 1000,
    keepalive: 30,
    clientId: 'CX-PWA-Prod-' + Date.now(),
  },
  dropletApiUrl: 'http://192.168.44.1:88/api',
  features: {
    analytics: {
      pageViews: true,
      errors: true,
    },
    environmentInfo: {
      enabled: false,
    },
    browserLogger: {
      enabled: false,
    },
  },
  services: {
    honeycomb: {
      endpoint: 'https://otel-collector-public.switchd.in:4319',
    },
    sentry: {
      dsn: 'https://455ba45cb4595b83644599c7447b0910@o4506311827259392.ingest.sentry.io/4506311829094400',
      dist: import.meta.env.NG_APP_SENTRY_DIST,
    },
  },
  testsRunning: false,
} satisfies EnvironmentInterface;
